/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     状态管理 getter
  +--------------------------------------------------------------------------------------
*/

import { array2Object } from '@/utils/common'

/**
 * arr2Obj: 数组转对象，value为键，title为值
 */
function arr2Obj (arr) {
  return arr.reduce((acc, cur) => {
    acc[cur.value] = cur.title
    return acc
  }, {})
}

const getters = {
  permissions: state => state.permissionStore.permissions,
  dynamicRoutes: state => state.permissionStore.dynamicRoutes,
  currentFrame: state => state.permissionStore.currentFrame,
  currentMenus: state => state.permissionStore.currentMenus,
  accessToken: state => state.userStore.accessToken,
  showEquip: state => state.equipStore.allequip.slice(state.equipStore.pindex * state.equipStore.psize, (state.equipStore.pindex + 1) * state.equipStore.psize),
  dispatchProcessObj: state => arr2Obj(state.mesStore.dispatchProcessArr),

  allQcSchemesObj (state) {
    return array2Object(state.qcStore.allQcSchemes, 'schemeid')
  },
  tmpUser (state) {
    return state.middleStore.TeamMember.find(item => {
      return item.uid == state.userStore.user.uid
    })
  }
}
export default getters
